import Vue from 'vue';
import {
  fetchPolicyholder as fetchPolicyholderApi,
  searchPolicyholders as searchPolicyholdersApi,
  searchPolicyholdersByLicensePlate as searchPolicyholdersByLicensePlateApi,
} from '../api';
import { Env } from '@/shared/config/environment';

const state = {
  policyholderData: {
    isLoading: false,
  },
  policyholders: {},
  policyholdersSearch: {
    isLoading: false,
  },
  policyholdersByLicensePlate: {
    isLoading: false,
  },
};

const mutations = {
  SET_LOADING_POLICYHOLDER_DATA(state, isLoading) {
    state.policyholderData.isLoading = isLoading;
  },
  SET_POLICYHOLDER_DATA(state, policyholder) {
    Vue.set(state.policyholders, policyholder.id, {
      ...policyholder,
      cachedAt: Date.now(),
    });
  },
  SET_LOADING_POLICYHOLDERS_SEARCH_LIST(state, isLoading) {
    state.policyholdersSearch.isLoading = isLoading;
  },
  SET_LOADING_POLICYHOLDERS_BY_LICENSE_PLATE_LIST(state, isLoading) {
    state.policyholdersByLicensePlate.isLoading = isLoading;
  },
};

const actions = {
  async fetchPolicyholder({ commit, dispatch, getters }, id) {
    const existingPolicyholder = getters.getPolicyholderById(id);
    if (existingPolicyholder) {
      return {
        ...existingPolicyholder,
      };
    }

    commit('SET_LOADING_POLICYHOLDER_DATA', true);

    try {
      const response = await fetchPolicyholderApi(id);

      if (response?.items?.length === 1) {
        commit('SET_POLICYHOLDER_DATA', response?.items[0]);

        return response?.items[0];
      }

      for (const policyholder in response?.items || []) {
        commit('SET_POLICYHOLDER_DATA', policyholder);
      }

      return response?.items;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити інформацію про страхувальника';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити інформацію про страхувальника',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_POLICYHOLDER_DATA', false);
    }
  },
  async searchPolicyholders({ commit, dispatch }, { searchText, customerType = null }) {
    commit('SET_LOADING_POLICYHOLDERS_SEARCH_LIST', true);

    try {
      return await searchPolicyholdersApi({ searchText, customerType });
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити список страхувальників';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список страхувальників',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_POLICYHOLDERS_SEARCH_LIST', false);
    }
  },
  async searchPolicyholdersByLicensePlate({ commit, dispatch }, { licensePlate, customerType = null }) {
    commit('SET_LOADING_POLICYHOLDERS_BY_LICENSE_PLATE_LIST', true);

    try {
      return await searchPolicyholdersByLicensePlateApi({ licensePlate, customerType });
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити список страхувальників';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список страхувальників',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_POLICYHOLDERS_BY_LICENSE_PLATE_LIST', false);
    }
  },
};

const getters = {
  isLoadingPolicyholdersList: state => state.policyholdersSearch.isLoading,
  isLoadingPolicyholdersByLicensePlateList: state => state.policyholdersByLicensePlate.isLoading,
  isLoadingPolicyholderData: state => state.policyholderData.isLoading,
  getPolicyholders: state => state.policyholders,
  getPolicyholderById: state => id => state.policyholders[id] || null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
